import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MenuItem from './MenuItem';
import { getMenu } from '../../../selectors';
import { setItemToConstruction, setItemToCart } from '../../../actions';
import { prepareCartItem } from '../../../helpers/menu-helpers';

import './ItemsList.scss';

const ItemsList = ({ items, onSelect, ...props }) => {
    const menu = useSelector(getMenu);
    const dispatch = useDispatch();

    function onMenuItemSelected(item) {
        const cartItem = prepareCartItem(menu.catalog, item.id);

        dispatch(setItemToConstruction(cartItem));

        if (onSelect) onSelect(item);
    }

    return (
        <div className="pi-menu-items-list">
            {(items || []).map(item => (
                <div key={item.id} className={`pi-menu-item-container`}>
                    <MenuItem item={item} onSelected={onMenuItemSelected} style={{ marginBottom: 10 }} />
                </div>
            ))}
            {Array(10).fill('empty').map((x, i) => <div key={x + i} className="pi-menu-item-container" />)}
        </div>
    );
};

export default ItemsList;
